/**
 * Created by zzy on 2019/8/8.
 */
import { loadRegionTree } from 'utils/tree'
import { Bar, AnnularPie, AppTreeSide, UniDatePicker } from 'components'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'

// 各区域接入、正常及异常数量统计
const barData = [
  ['各区域数量对比', '接入', '正常', '报警']
]
//
const barColor = ['#4CA2EB', '#41CF87', '#FFA03A']

// 各种状态数量统计
const pieData = [
  ['状态占比', '正常', '偏亮', '偏暗', '偏色', '噪声', '条纹', '图像模糊', '画面冻结', '视频丢失', '画面抖动'],
  ['正常', 0],
  ['偏亮', 0],
  ['偏暗', 0],
  ['偏色', 0],
  ['噪点', 0],
  ['条纹', 0],
  ['图像模糊', 0],
  ['画面冻结', 0],
  ['视频丢失', 0],
  ['画面抖动', 0]
]
const pieColor = ['#41CF87', '#FFA03A', '#FFF06E', '#FF6B6B', '#664CEB', '#4CA2EB', '#4CCFEB', '#4CEBD3', '#8E41CF', '#7FB80e']
const pieTitle = {
  text: '状态占比',
  left: '30%',
  top: '45%'
}
const pieLegend = {
  orient: 'vertical',
  top: '4%',
  right: '4%',
  itemGap: 15
}

export default {
  name: 'VideoDiagnosisStatistics',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 树数据
      treeData: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 表格数据
      tableData: [],
      tableTotalRow: 0,
      // 表格查询条件
      date: '',
      tableQueryParams: {
        parentRegionId: -1,
        statDate: 0,
        pageNum: 1,
        pageSize: 10
      },
      // 遮罩层
      loading: false,
      // pie和bar数据
      barId: 'bar',
      barData: barData,
      barColor: barColor,
      pieId: 'annular-pie',
      pieData: pieData,
      pieColor: pieColor,
      pieTitle: pieTitle,
      pieLegend: pieLegend,
      pieQueryParams: {
        regionId: -1,
        statDate: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  components: {
    Bar,
    AnnularPie,
    AppTreeSide,
    UniDatePicker
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  mounted () {
    this.date = new Date()

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()
    })
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点为当前节点
            this.$refs.tree.setCurrentKey(this.treeData[0].key)
            // 单击当前节点
            this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
          }
        })
      })
    },
    // 查询视频诊断统计
    getVideoDiagnosisStatByRegionList() {
      this.pieQueryParams.statDate = Number(this.date.Format('yyyyMMdd'))
      this.$http(this.$api.videoDiagnosisStatByRegionList, this.pieQueryParams).then(
        res => {
          if (res.code === 200) {
            if (res.data.length) {
              // 正常
              this.pieData[1][1] = res.data[0].normalCount
              // 偏亮
              this.pieData[2][1] = res.data[0].brightHighCount
              // 偏暗
              this.pieData[3][1] = res.data[0].brightLowCount
              // 偏色
              this.pieData[4][1] = res.data[0].colorCastCount
              // 噪点
              this.pieData[5][1] = res.data[0].notDoneCount
              // 条纹
              this.pieData[6][1] = res.data[0].striageCount
              // 图像模糊
              this.pieData[7][1] = res.data[0].contrastLowCount
              // 画面冻结
              this.pieData[8][1] = res.data[0].freezeCount
              // 视频丢失
              this.pieData[9][1] = res.data[0].lostCount
              // 画面抖动
              this.pieData[10][1] = res.data[0].shakeCount
            } else {
              for (let i = 0; i < 10; i++) {
                this.pieData[i + 1][1] = 0
              }
            }
            this.$nextTick(() => {
              this.$refs.annularPie.draw()
            })
          }
        }
      )
    },
    // 查询视频诊断统计2
    getVideoDiagnosisStatByRegionList2() {
      this.tableQueryParams.statDate = Number(this.date.Format('yyyyMMdd'))
      this.$http(this.$api.videoDiagnosisStatByRegionList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              item.alarmCount = item.totalCount - item.normalCount
            })

            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow

            // 绘制bar
            let xData = ['各区域数量对比', '接入', '正常', '报警']
            this.barData = []
            this.barData.push(xData)
            if (res.data.length) {
              res.data.forEach(item => {
                let yItem = []
                yItem.push(item.regionName)
                yItem.push(item.totalCount)
                yItem.push(item.normalCount)
                yItem.push(item.alarmCount)
                this.barData.push(yItem)
              })
            } else {
              let yItem = ['', 0, 0, 0]
              this.barData.push(yItem)
            }
            this.$nextTick(() => {
              this.$refs.bar.draw()
            })
          }
        }
      )
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (this.tableQueryParams.parentRegionId !== obj.id) {
        this.tableQueryParams.parentRegionId = obj.id
        this.tableQueryParams.pageNum = 1
        this.getVideoDiagnosisStatByRegionList2()
      }
      if (this.pieQueryParams.regionId !== obj.id) {
        this.pieQueryParams.regionId = obj.id
        this.pieQueryParams.pageNum = 1
        this.getVideoDiagnosisStatByRegionList()
      }
    },
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.page = 1
      this.getVideoDiagnosisStatByRegionList()
      this.getVideoDiagnosisStatByRegionList2()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.tableQueryParams.regionId = 0
      this.tableQueryParams.statDate = 0
      this.date = new Date()
      this.tableQueryParams.pageNum = 1

      this.pieQueryParams.parentRegionId = 0
      this.tableQueryParams.statDate = 0
      this.date = new Date()
      this.tableQueryParams.pageNum = 1
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getVideoDiagnosisStatByRegionList2()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getVideoDiagnosisStatByRegionList2()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/statistics/videoDiagnosisStatistics/VideoDiagnosisStatistics.js